import { render, staticRenderFns } from "./Guide_4.vue?vue&type=template&id=c0e3b584&scoped=true&"
import script from "./Guide_4.vue?vue&type=script&lang=js&"
export * from "./Guide_4.vue?vue&type=script&lang=js&"
import style0 from "./Guide_4.vue?vue&type=style&index=0&id=c0e3b584&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e3b584",
  null
  
)

export default component.exports